import Notifier from '@/Services/Notifier';
window.axios = require('axios');
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.interceptors.response.use(response => {
    Notifier.sendNotificationsIfNeeded(response.data);
    return response;
}, error => {
    console.log(error);
    if (typeof error === 'object' && Object.prototype.hasOwnProperty.call(error, 'response') && error.response.data) {
        Notifier.sendNotificationsIfNeeded(error.response.data);
    }
    return Promise.reject(error);
});
